var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopilot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5502 1.16374C11.4516 0.827855 11.2468 0.532957 10.9665 0.323175C10.6863 0.113392 10.3456 6.11179e-06 9.99554 -1.52584e-05H9.52303C9.144 -2.34558e-05 8.77695 0.132834 8.48574 0.375448C8.19453 0.618063 7.99757 0.955083 7.92913 1.32789L7.11853 5.74245L7.31978 5.05469C7.41817 4.71837 7.62293 4.423 7.90335 4.21287C8.18378 4.00274 8.52476 3.88917 8.87518 3.88919H11.6237L12.7766 4.33789L13.8879 3.88884H13.5638C13.2137 3.8889 12.8729 3.77555 12.5926 3.56576C12.3123 3.35597 12.1074 3.06103 12.0087 2.72509L11.5502 1.16374Z",
    fill: "url(#paint0_radial_27_848)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.616 12.8296C4.71359 13.1671 4.91823 13.4638 5.19909 13.6749C5.47995 13.886 5.8218 14.0001 6.17315 14H7.17765C7.6002 14.0001 8.00605 13.8351 8.3087 13.5402C8.61135 13.2453 8.78686 12.8439 8.79781 12.4215L8.90701 8.16446L8.67811 8.94601C8.57967 9.28221 8.37494 9.57746 8.09459 9.78752C7.81424 9.99758 7.47337 10.1111 7.12305 10.1112H4.3514L3.36335 9.57496L2.2934 10.1112H2.6126C2.96382 10.1112 3.30552 10.2254 3.58624 10.4365C3.86696 10.6476 4.07149 10.9442 4.16905 11.2816L4.6167 12.8296H4.616Z",
    fill: "url(#paint1_radial_27_848)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.92555 -1.52588e-05H4.31154C2.70749 -1.52588e-05 1.74533 2.11994 1.10378 4.23954C0.343582 6.7515 -0.65147 10.1098 2.22659 10.1098H4.65034C5.00274 10.1101 5.34563 9.99551 5.62707 9.78342C5.9085 9.57134 6.11313 9.27329 6.20994 8.93445C6.78129 6.93043 7.36125 4.92888 7.9498 2.92984C8.24485 1.93479 8.4902 1.08044 8.86715 0.548086C9.07855 0.249885 9.43065 -1.52588e-05 9.92555 -1.52588e-05Z",
    fill: "url(#paint2_linear_27_848)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.92555 -1.52588e-05H4.31154C2.70749 -1.52588e-05 1.74533 2.11994 1.10378 4.23954C0.343582 6.7515 -0.65147 10.1098 2.22659 10.1098H4.65034C5.00274 10.1101 5.34563 9.99551 5.62707 9.78342C5.9085 9.57134 6.11313 9.27329 6.20994 8.93445C6.78129 6.93043 7.36125 4.92888 7.9498 2.92984C8.24485 1.93479 8.4902 1.08044 8.86715 0.548086C9.07855 0.249885 9.43065 -1.52588e-05 9.92555 -1.52588e-05Z",
    fill: "url(#paint3_linear_27_848)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.07489 14H11.6889C13.2926 14 14.2551 11.8797 14.8967 9.75974C15.6565 7.24778 16.6512 3.88847 13.7739 3.88847H11.3498C10.9974 3.88823 10.6546 4.00283 10.3732 4.21491C10.0919 4.42699 9.8873 4.725 9.7905 5.06378C9.21901 7.06826 8.63894 9.07028 8.05029 11.0698C7.75559 12.0648 7.50989 12.9195 7.13329 13.4519C6.92189 13.7501 6.56979 14 6.07489 14Z",
    fill: "url(#paint4_radial_27_848)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.07489 14H11.6889C13.2926 14 14.2551 11.8797 14.8967 9.75974C15.6565 7.24778 16.6512 3.88847 13.7739 3.88847H11.3498C10.9974 3.88823 10.6546 4.00283 10.3732 4.21491C10.0919 4.42699 9.8873 4.725 9.7905 5.06378C9.21901 7.06826 8.63894 9.07028 8.05029 11.0698C7.75559 12.0648 7.50989 12.9195 7.13329 13.4519C6.92189 13.7501 6.56979 14 6.07489 14Z",
    fill: "url(#paint5_linear_27_848)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_27_848",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.9023 5.7799) rotate(-129.304) scale(6.05616 5.69472)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#00AEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773,
    stopColor: "#2253CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0736C4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_27_848",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.49299 10.0859) rotate(51.84) scale(5.59693 5.42917)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB657"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.634,
    stopColor: "#FF5F3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.923,
    stopColor: "#C02B3C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_27_848",
    x1: 3.97554,
    y1: 1.22499,
    x2: 4.77634,
    y2: 10.4913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.156,
    stopColor: "#0D91E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    stopColor: "#52B471"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652,
    stopColor: "#98BD42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.937,
    stopColor: "#FFC800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_27_848",
    x1: 4.67554,
    y1: -0.0000152573,
    x2: 5.11304,
    y2: 10.1098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DCBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247,
    stopColor: "#0588F7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_27_848",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.0618 2.89836) rotate(109.274) scale(13.4356 16.0954)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.066,
    stopColor: "#8C48FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F2598A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.896,
    stopColor: "#FFB152"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_27_848",
    x1: 14.5057,
    y1: 3.27107,
    x2: 14.4998,
    y2: 6.02523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.058,
    stopColor: "#F8ADFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.708,
    stopColor: "#A86EDD",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopilot);
export default __webpack_public_path__ + "static/media/copilot.54330ab4cfaca0f9c5f3d426d7197e3b.svg";
export { ForwardRef as ReactComponent };